$(".step-tabs li a").click(function (e) {
  e.preventDefault();
  var index = $(this).parent().index();
  $(".step-tabs li a").removeClass("active");
  $(this).addClass("active");
  // Hide all tab contents and show the one matching the index
  $(".tab-content").hide().eq(index).fadeIn();
  $(".images img").hide().eq(index).fadeIn();
});

// Set the first tab as active on page load
$(".step-tabs li:first-child a").addClass("active");
$(".tab-content").hide().first().show();
$(".images img").hide().first().show();
